<script>
    import { onMount } from 'svelte';
    import { auth } from '../../services/auth.js';
    import AddressForm from '../../components/AddressForm.svelte';
    import Alert from '../../components/Alert.svelte';

    var address;
    var loading = true;
    var saving = false;
    var savedMsg = "";
    var errorMsg = "";

    onMount(() => {
        auth.getUserDetails(loadAddress);
    })

    function loadAddress(attrs){
        var userAddress = attrs.find((a) => a.name === 'address');
        if(userAddress){
            address = JSON.parse(userAddress.value);
            loading = false;
        }
    }

    function saveAddress(){
        var isValid = validateAddress();

        if(isValid){
            saving = true;
            auth.updateUserDetails("address", JSON.stringify(address), showResults)
        }
    }

    function showResults(result){
        saving = false;

        if(result){
            savedMsg = "Address Saved!";
            setTimeout(() => savedMsg = "", 10000);
        }else{
            errorMsg = "Update failed! Unknown error occurred!";
            setTimeout(() => errorMsg = "", 10000);
        }
    }

    function validateAddress(){
        // TODO: Add validation
        return true;
    }
</script>

<h2>Address</h2>
<form id="address-form">
    {#if savedMsg}
    <Alert type="success" icon="check">{savedMsg}</Alert>
    {/if}

    {#if errorMsg}
    <Alert type="danger" icon="warning">{errorMsg}</Alert>
    {/if}

    <AddressForm bind:address />

    <div class="form-actions">
        <button class="btn" class:btn-success={savedMsg} class:btn-danger={errorMsg} on:click|preventDefault={saveAddress} disabled={saving || savedMsg}>
            {#if saving}
            <svg class="icon spin"><use href="/icons.svg#circle_notch"></use></svg> Saving...
            {:else if savedMsg}
            <svg class="icon"><use href="/icons.svg#check"></use></svg> Saved!
            {:else if errorMsg}
            <svg class="icon"><use href="/icons.svg#clear"></use></svg> Error!
            {:else}
            Update Address
            {/if}
        </button>
    </div>
</form>

<style>
    .address-actions{
        display: flex;
        justify-content: flex-end;
        margin: var(--spacing) 0;
    }
</style>

